import React, { useContext, useEffect } from 'react'
import { ThemeContext } from 'styled-components'
import PropTypes from 'prop-types'
import styled from 'styled-components'
const getWidthString = (span) => {
    if (span) {
        let width = span / 24 * 100;
        return `width: ${width}%;`
    }
    // else {
    //     return `width: auto ;`
    // }
}
const Column = styled.div`
    display  : ${props => props.display || 'flex'} ;
    direction : ${props => props.lang && (props.lang === 'fa' || props.lang === 'ar') ? 'rtl' : props.lang && (props.lang !== 'fa' || props.lang !== 'ar') ? 'ltr' : 'rtl'};
    justify-content : ${props => props.justifyContent || 'center'};
    align-items : ${props => props.alignItems || 'center'};
    position : ${props => props.position || 'static'};
    color : ${props => props.color || props.theme.text};
    flex-direction : ${props => props.flexDir ? props.flexDir : props.style ? props.style.flexDirection : props.className ? props.className.flexDirection : 'row'} ;
    flex-wrap : ${props => props.flexWrap || 'no-wrap'};
    /* height : ${props => props.height ? props.height : props.style ? props.style.height : props.className ? props.className.height : '100%'}; */
    background-position : center ;
    background-size : cover ;
    background-repeat : no-repeat ;
     background:${props => props.loading === true && 'linear-gradient(-90deg, #F0F0F0 0%, #F8F8F8 50%, #F0F0F0 100%)'};
  background-size: ${props => props.loading === true && '400% 400%'} ;
  animation: ${props => props.loading === true ? `pulse 0.55s ease-in-out 0ms infinite` : 'none'};
  border-radius : ${props => props.loading === true && '10px'};
  height : ${props => props.loading === true && props.skeletonType === 'line' && '25px !important'};
  min-height : ${props => props.loading === true && props.skeletonType === 'line' && '25px !important'};
  margin-bottom :${props => props.loading === true && '15px'} ;
  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  };
    border-radius : ${props => props.borderRadius ? props.borderRadius : props.style ? props.style.borderRadius : 'none'};
    border-radius : ${props => props.border ? props.border : props.style ? props.style.border : 'none'};
    ${(props) => getWidthString(props.xl)}
    @media screen and (max-width: 1280px) {
        ${(props) => getWidthString(props.lg)}
    } 
    @media screen and (max-width: 992px) {
        ${(props) => getWidthString(props.md)}
    } 
    @media  screen and (max-width: 768px) {
        ${(props) => getWidthString(props.sm)}
    }
    @media  screen and (max-width: 480px) {
        ${(props) => getWidthString(props.xs)}
    }`
const Col = (props) => {
    const theme = useContext(ThemeContext)
    return (
        <Column
            {...props}
            ref={props.innerRef}
            theme={theme}
            onClick={props.onClick}
        >
            {props.children}
        </Column>
    )
}

export default Col
